module.exports = __webpack_public_path__ + "static/media/11NEPAD1.484d8435.jpg";